import React, { useEffect, createElement } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductSection } from './components/ProductSection';
import { FinalCTASection } from './components/FinalCTASection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    // Set page title and meta for link previews
    document.title = 'IA para Docentes';
    // Add/update meta description for link sharing
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Aprendé a crear tu propio material con IA en 10 minutos. Para siempre.';
    // Open Graph tags for link previews
    const ogTags = [{
      property: 'og:title',
      content: 'IA para Docentes'
    }, {
      property: 'og:description',
      content: 'Aprendé a crear tu propio material con IA en 10 minutos. Para siempre.'
    }, {
      property: 'og:type',
      content: 'website'
    }];
    ogTags.forEach(({
      property,
      content
    }) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  useEffect(() => {
    // Meta Pixel
    const pixelId = '1245152907821897';
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      }) as any;
      (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    // noscript fallback
    const noscript = document.createElement('img');
    noscript.height = 1;
    noscript.width = 1;
    noscript.style.display = 'none';
    noscript.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    document.body.appendChild(noscript);
    return () => {
      if (noscript.parentNode) noscript.parentNode.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen w-full bg-offwhite font-inter text-charcoal selection:bg-gold/30 selection:text-navy overflow-x-hidden" data-id="element-0">
      <StickyTopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <PainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <FinalCTASection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
      </main>

      <FooterSection data-id="element-12" />
    </div>;
}